export function isEmailValid(email) {
    const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return filter.test(email);
}

export function isPhoneNumberValid(phone) {
    return (phone.match(/\d/g) || []).length === 10;
}
